var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdentify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1.Bace\u57FA\u7840/3.Icon\u56FE\u6807/\u7528\u6237/user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.Bace\\u57FA\\u7840/3.Icon\\u56FE\\u6807/\\u7528\\u6237/user",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.79752908e-06,2.79752908e-06 L15.9999972,2.79752908e-06 L15.9999972,16.0000028 L-2.79752908e-06,16.0000028 L-2.79752908e-06,2.79752908e-06 Z",
    id: "Rectangle-4117",
    fillOpacity: 0,
    fill: "#C4C4C4",
    transform: "translate(7.999997, 8.000003) rotate(0.000020) translate(-7.999997, -8.000003) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,8.5 C6.06700325,8.5 4.5,6.93299675 4.5,5 C4.5,3.06700301 6.06700325,1.5 8,1.5 C9.93299675,1.5 11.5,3.06700301 11.5,5 C11.5,6.93299675 9.93299675,8.5 8,8.5 Z M8,7.5 C6.61928749,7.5 5.5,6.38071156 5.5,5 C5.5,3.61928773 6.61928749,2.5 8,2.5 C9.38071156,2.5 10.5,3.61928773 10.5,5 C10.5,6.38071203 9.38071156,7.5 8,7.5 Z M14.5,11.7246284 L14.5,14 C14.5,14.2761421 14.2761421,14.5 14,14.5 L2,14.5 C1.72385892,14.5 1.5,14.2761421 1.5,14 L1.5,11.7246284 C1.5,11.3546562 1.70301592,11.0122261 2.03686422,10.8527746 C3.84940308,9.98707581 5.86650896,9.5 8,9.5 C10.1334915,9.5 12.1505976,9.98707581 13.9631367,10.8527746 C14.2969847,11.0122261 14.5,11.3546562 14.5,11.7246284 Z M13.5,11.739831 L13.5,13.5 L2.5,13.5 L2.5,11.739831 C4.17434502,10.9457273 6.03340387,10.5 8,10.5 C9.9665966,10.5 11.8256559,10.9457273 13.5,11.739831 Z",
    id: "Union",
    fillOpacity: 0.9,
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentify);
export default __webpack_public_path__ + "static/media/identify.c5b282f4482b0ec0cc8366ee8c876ad2.svg";
export { ForwardRef as ReactComponent };